// Keep both gates reversible. Coordinate these settings with server subscription properties.
export const subscriptionPolicy = {
  // Build with REACT_APP_SUBSCRIPTION_ENFORCED=true to restore paid access.
  enforced: process.env.REACT_APP_SUBSCRIPTION_ENFORCED === "true",
  freeScreensEnabled: true,
};

export const isSubscriptionExpired = (user) => subscriptionPolicy.enforced && !user?.isAdmin
  && (!user?.usage || user.usage.expired !== false
    || (Number.isFinite(user.usage.to) && user.usage.to <= Date.now()));

export const freeScreenScope = (pathname = window.location.pathname) => {
  if (!subscriptionPolicy.freeScreensEnabled) return null;
  if (pathname === "/dashboard/apts/newwindow") return "apartment";
  if (pathname === "/dashboard/home" || pathname === "/dashboard"
      || pathname.startsWith("/dashboard/condition/")) return "nationwide";
  return null;
};
export const canOpenWithoutSubscription = (pathname) => Boolean(freeScreenScope(pathname))
  || ["/dashboard/analyze/notes", "/dashboard/analyze/note-newwindow", "/dashboard/analyze/note-folder-window"].includes(pathname)
  || ["/dashboard/guide/", "/dashboard/pricing", "/dashboard/mypage", "/dashboard/community", "/dashboard/settings/"].some(path => pathname.startsWith(path));

// Client routing is convenience only; the server independently validates each free contract.
export const freeReadPath = (url, method = "get", scope = freeScreenScope()) => {
  // Header keyword search remains available on every route, including paid-page gates.
  if (subscriptionPolicy.freeScreensEnabled && method.toLowerCase() === "post") {
    if (url === "/apts/search") return "/free/property-search/apartments";
    if (url === "/apts/sp/search") return "/free/property-search/supply-pyeongs";
  }
  if (!scope) return url;
  const neighborMaps = { "/apts/select/map": "apt", "/apts/sp/select/map": "sp", "/apts/mp/select/map": "mp" };
  if (scope === "apartment" && method.toLowerCase() === "post" && neighborMaps[url]) {
    const aptId = new URLSearchParams(window.location.search).get("id");
    return `/free/apartments/${encodeURIComponent(aptId)}/neighbors/map/${neighborMaps[url]}`;
  }
  if (method.toLowerCase() === "post" && url === "/apts/movein/drilldown") return `/free${url}`;
  if (method.toLowerCase() !== "get") return url;
  const path = url.split("?")[0];
  const exact = ["/dashboard/briefing", "/dashboard/weekly-gungu-chart", "/dashboard/stats", "/dashboard/stat-dates",
    "/market-opportunity/status", "/market-opportunity/apts", "/market-opportunity/top-apts",
    "/screening/score-config", "/screening/results", "/screening/history", "/screening/dates", "/apts/top-by-sido"];
  const patterns = [/^\/screening\/result\/(SIDO|GUNGU)\/[^/]+$/,
    /^\/apts\/[^/]+\/(cinfo|pyeongs\/cinfo|pyeongs\/mes)$/,
    /^\/apts\/spyeongs\/[^/]+\/(size-undervalue|price-undervalue|flow-undervalue)$/,
    /^\/education\/schools\/(?!region$)[^/]+$/];
  return exact.includes(path) || patterns.some(pattern => pattern.test(path)) ? `/free${url}` : url;
};

// Never share private request caches across account/token transitions or free and paid contexts.
let lastToken;
let session = 0;
export const dataAccessScope = () => {
  const token = sessionStorage.getItem("accessToken");
  if (lastToken !== token) { lastToken = token; session += 1; }
  return `${session}:${freeScreenScope() || "paid"}`;
};
